import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import { PauseOrderTypes } from '../../../../domain/models/PauseOrderTypes';

const useStyles = makeStyles(theme => ({
  selected: {
    color: `${theme.palette.primary.main} !important`,
    background: `transparent !important`
  }
}));

interface SelectOrderTimeTypeProps {
  onChange?: (asap: boolean) => void;
  disabled?: boolean;
  value?: boolean;
  isWorking?: boolean;
  pauseOrder?: PauseOrderTypes;
}

const SelectOrderTimeType: FC<SelectOrderTimeTypeProps> = ({
  value,
  onChange,
  disabled,
  isWorking,
  pauseOrder
}) => {
  const classes = useStyles();
  const handleValueChange = (_e: any, newValue: boolean | null) => {
    if (newValue !== null && onChange) {
      onChange(newValue);
    }
  };

  return useObserver(() => (
    <Grid>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="flex-start"
      >
        <Typography variant="caption" color="primary">
          {'When would you like to order?'}
        </Typography>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleValueChange}
          aria-label="ASAP Later"
        >
          <ToggleButton
            key="asap"
            value={true}
            aria-label="order asap"
            disabled={
              !isWorking ||
              (pauseOrder !== undefined && pauseOrder !== PauseOrderTypes.NONE)
            }
            classes={{
              selected: classes.selected
            }}
          >
            ASAP
          </ToggleButton>
          <ToggleButton
            key="later"
            value={false}
            aria-label="order later"
            disabled={disabled}
            classes={{
              selected: classes.selected
            }}
          >
            LATER
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  ));
};

export default SelectOrderTimeType;
